import './NoteDisplay.css'
import Note from '../Note'
import { Component, useState } from 'react'

import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File

class NoteDisplay extends Component {

  constructor(props){
    super(props);
    this.state = { 
      note: this.props.note || new Note()
    }
  }
   
  static getDerivedStateFromProps(nextProps, prevState){
    return {note: nextProps.note}
  }

  saveNote = (e) => {
    e.preventDefault()
    if(this.state.note.title == '' || this.state.note.text == ''){
      alert("Title or Note cannot be empty!")
      return;
    }
    this.props.saveCurrentNote(this.state.note)
  }

  deleteNote = (e) => {
    e.preventDefault()
    this.props.deleteNote(this.state.note.id)
  }

  changeTitle(titleValue) {
    let note = this.state.note
    note.title = titleValue
    this.setState({note: note })
  }

  changeText(textValue) {
    console.log(textValue)
    let note = this.state.note
    note.text = textValue
    this.setState({note: note})
  }

  render(){
    const {contentState} = this.state;
    return (
      <div className='note-container'>
        <form className='w3-container w3-light-grey'>
          <p>
            <label>
              <strong>Title</strong>
            </label>
            <input
              className='w3-input w3-border w3-border-teal'
              name='title'
              type='text'
              value={this.state.note.title}
              onChange={(e) => this.changeTitle(e.target.value)}
            />
          </p>
          
          <p>
            <label>
              <strong>Note</strong>
            </label>
            <SunEditor 
                      setContents={this.state.note.text}  
                      showToolbar={true} enableToolbar={true}
                      onChange={this.changeText.bind(this)}
                    />
          </p>
          <button className='w3-button w3-green w3-card' onClick={this.saveNote}>
            Save Note!
          </button>
          <button className='w3-button w3-red w3-card' onClick={this.deleteNote}>
            Delete Note!
          </button>
        </form>
      </div>
    )
  };
}

export default NoteDisplay
